import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "SCHEDULING_ORDER_FOB_" }
);

export interface SchedulingOrderFOBState extends IState {}

const INITIAL_STATE: SchedulingOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: SchedulingOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: SchedulingOrderFOBState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: SchedulingOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const schedulingOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const SchedulingOrderFOBTypes = Types;
export const SchedulingOrderFOBActions = Creators;
